import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="container" style={{ padding: 'var(--spacing-8) 0' }}>
      <div className="row justify-center">
        <div className="col col--8">
          <div className="card p-6">
            <h1 style={{ marginBottom: 'var(--spacing-6)' }}>Terms of Service</h1>
            
            <div style={{ lineHeight: 1.6 }}>
              <p><strong>Last updated:</strong> January 2024</p>
              
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing and using GradedWash ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>

              <h2>2. Description of Service</h2>
              <p>GradedWash is a travel companion matching platform that connects travelers based on personality compatibility. Our service includes:</p>
              <ul>
                <li>Personality-based matching system</li>
                <li>Travel companion search and discovery</li>
                <li>Local meetup organization</li>
                <li>Travel group coordination</li>
                <li>Messaging and communication tools</li>
                <li>Travel blog and content</li>
              </ul>

              <h2>3. User Accounts</h2>
              <p>To use our service, you must:</p>
              <ul>
                <li>Be at least 18 years old</li>
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account</li>
                <li>Notify us immediately of any unauthorized use</li>
                <li>Not share your account credentials with others</li>
              </ul>

              <h2>4. User Conduct</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Use the service for any illegal or unauthorized purpose</li>
                <li>Harass, abuse, or harm other users</li>
                <li>Post false, misleading, or inappropriate content</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with the proper functioning of the service</li>
                <li>Use automated systems to access the service</li>
              </ul>

              <h2>5. Safety and Security</h2>
              <p>While we strive to create a safe environment, you acknowledge that:</p>
              <ul>
                <li>You are responsible for your own safety when meeting other users</li>
                <li>We cannot guarantee the identity or intentions of other users</li>
                <li>You should exercise caution and common sense when meeting people</li>
                <li>We recommend meeting in public places initially</li>
                <li>You should report any suspicious or inappropriate behavior</li>
              </ul>

              <h2>6. Content and Intellectual Property</h2>
              <p>You retain ownership of content you post, but grant us a license to use it for service provision. You agree not to post content that:</p>
              <ul>
                <li>Infringes on others' intellectual property rights</li>
                <li>Is defamatory, obscene, or offensive</li>
                <li>Contains personal information of others without consent</li>
                <li>Promotes illegal activities or harmful behavior</li>
              </ul>

              <h2>7. Privacy and Data Protection</h2>
              <p>Your privacy is important to us. Our collection and use of personal information is governed by our Privacy Policy, which is incorporated into these terms by reference.</p>

              <h2>8. Payment Terms</h2>
              <p>Some features may require payment. By making a payment, you agree to:</p>
              <ul>
                <li>Pay all charges at the prices in effect</li>
                <li>Provide accurate billing information</li>
                <li>Authorize us to charge your payment method</li>
                <li>Pay any applicable taxes</li>
              </ul>

              <h2>9. Disclaimers</h2>
              <p>The service is provided "as is" without warranties of any kind. We disclaim all warranties, including:</p>
              <ul>
                <li>Warranties of merchantability and fitness for purpose</li>
                <li>Warranties that the service will be uninterrupted or error-free</li>
                <li>Warranties regarding the accuracy of matching results</li>
                <li>Warranties regarding the safety of user interactions</li>
              </ul>

              <h3>9.1 Local Meets Disclaimer</h3>
              <p><strong>Important:</strong> Local Meets are organized entirely by community members, not by GradedWash. We provide the platform and tools for members to create and join meets, but we are not responsible for any events, activities, or behaviors that occur at these meets.</p>
              <ul>
                <li>All Local Meets are organized by community members, not by GradedWash</li>
                <li>Participants attend Local Meets at their own risk</li>
                <li>GradedWash is not responsible for any incidents, injuries, or damages that occur at Local Meets</li>
                <li>We strongly encourage all members to follow safety guidelines and report any concerning behavior</li>
                <li>While we provide safety guidelines and reporting tools, we cannot guarantee the safety of any meet</li>
                <li>We recommend meeting in public places and following our safety guidelines</li>
              </ul>

              <h3>9.2 Travel Services Disclaimer</h3>
              <p><strong>Travel Agent Role:</strong> GradedWash acts solely as a travel agent connecting you with third-party travel providers. We do not organize, operate, or provide any travel services ourselves.</p>
              <ul>
                <li>We connect you with trusted travel companies and tour operators</li>
                <li>All bookings are made with third-party providers, not through GradedWash directly</li>
                <li>We are not responsible for the quality, safety, or delivery of travel services</li>
                <li>Any issues with travel bookings should be resolved with the travel provider directly</li>
                <li>We provide information and guidance but do not manage travel bookings or customer service</li>
              </ul>

              <h2>10. Limitation of Liability</h2>
              <p>To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to:</p>
              <ul>
                <li>Loss of profits, data, or use</li>
                <li>Personal injury or property damage</li>
                <li>Emotional distress or mental anguish</li>
                <li>Damages arising from user interactions</li>
              </ul>

              <h2>11. Indemnification</h2>
              <p>You agree to indemnify and hold harmless GradedWash from any claims, damages, or expenses arising from your use of the service or violation of these terms.</p>

              <h2>12. Termination</h2>
              <p>We may terminate or suspend your account at any time for violations of these terms. You may also terminate your account at any time by contacting us.</p>

              <h2>13. Changes to Terms</h2>
              <p>We reserve the right to modify these terms at any time. We will notify users of material changes by posting the updated terms on our website.</p>

              <h2>14. Governing Law</h2>
              <p>These terms are governed by the laws of [Your Jurisdiction]. Any disputes shall be resolved in the courts of [Your Jurisdiction].</p>

              <h2>15. Contact Information</h2>
              <p>If you have questions about these terms, please contact us at:</p>
              <p>
                <strong>Email:</strong> legal@gradedwash.com<br/>
                <strong>Address:</strong> [Your Business Address]<br/>
                <strong>Phone:</strong> [Your Phone Number]
              </p>
            </div>

            <div style={{ marginTop: 'var(--spacing-6)', paddingTop: 'var(--spacing-4)', borderTop: '1px solid var(--gray-200)' }}>
              <Link to="/" className="btn btn--primary">Back to Home</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 